export const mockPayload = {
  locationTypes: ['Interior', 'Exterior', 'Glass', 'Under the Hood']
};

export const CONSTS = {
  MECHANICAL: 'Mechanical',
  COSMETIC: 'Cosmetic'
};

export const CATEGORIES = {
  MECHANICAL: 'How it Works',
  COSMETIC: 'How it Looks'
};

export const eventableTypes = {
  submitClicked: 'Submit Photos Clicked',
  continueModalClicked: 'Continue Clicked on Cosmetic Disclaimer',
  getStartedClicked: 'get_started_ASR',
  modalClosed: 'Modal Closed',
  createDetailsSubmitted: 'ASR_submit',
  confirmationScreen: 'Confirmation Screen Confirmed',
  findRepairFacility: 'Find_repair_facility',
  addPhoto: 'Add Photo Clicked',
  asrViewDetails: 'ASR_view_details',
  landOnPSD: 'land_PSD'
};

// Mechanical
export const mechanicalCategory = [
  'Brakes',
  'Display Screens',
  'Other Electrical',
  'Other Mechanical',
  'Tires',
  'Wheel / Rim'
];

export const mechanicalSubCategory = [
  'Check Engine Light',
  'Damaged (Cracked / Condensation / etc.)',
  'Not Working',
  'Odd Sounds/Noises',
  'Other',
  'Shaking or Vibration'
];

// Cosmetic
export const cosmeticType = [
  'Cosmetic - Exterior',
  'Cosmetic - Interior',
  'Windshield / Glass'
  // 'Cleanliness / Stains',
];

// Question 1
// Cosmetic Categories/Types
export const cosmeticExterior = [
  'Bumper',
  'Door',
  'Fender (Front)',
  'Grille',
  'Headlight',
  'Hood',
  'Pillar',
  'Quarter Panel (Rear)',
  'Rocker Panels',
  'Roof',
  'Side Mirrors',
  'Taillight',
  'Trunk / Lift Gate',
  'Wheel / Rim'
];

export const cosmeticInterior = [
  'Carpet / Floor',
  'Console Buttons',
  'Cup Holders',
  'Dashboard',
  'Door Panel',
  'Head / Roof Liner',
  'Interior Trim',
  'Seat / Seat Cushion',
  'Visor'
];

export const windshieldGlass = ['Rear Window', 'Side Window', 'Windshield'];

export const fromCosmeticType = {
  cosmeticexterior: cosmeticExterior,
  cosmeticinterior: cosmeticInterior,
  windshieldglass: windshieldGlass
};

// Question 2
// Cosmetic Exterior Locations
const exteriorFrontOfCar = ['Driver Front', 'Passenger Front'];

const exteriorFrontOrBack = ['Back', 'Front'];

const exteriorCorners = [
  'Driver Front',
  'Driver Rear',
  'Passenger Front',
  'Passenger Rear'
];

// Cosmetic Interior Locations
const interiorAll = [
  'Driver Seat / Side',
  'Passenger Seat / Side',
  'Second Row',
  'Third Row',
  'Trunk'
];

const interiorFront = ['Driver Seat / Side', 'Passenger Seat / Side'];

export const fromLocation = {
  // Cosmetic exterior
  fenderfront: exteriorFrontOfCar,
  sidemirrors: exteriorFrontOfCar,
  bumper: exteriorFrontOrBack,
  roof: exteriorFrontOrBack,
  door: exteriorCorners,
  rockerpanels: exteriorCorners,
  wheelrim: exteriorCorners,
  quarterpanelrear: exteriorCorners,
  // Cosmetic Interior
  seatseatcushion: interiorAll,
  interiortrim: interiorAll,
  carpetfloor: interiorAll,
  headroofliner: interiorAll,
  cupholders: interiorAll,
  doorpanel: interiorAll,
  consolebuttons: interiorFront,
  dashboard: interiorFront,
  visor: interiorFront,
  // Windshield / Glass
  // windshield: something,
  // rearwindow: something,
  sidewindow: exteriorCorners
};

// Question 3
export const exteriorIssueDescription = [
  'Damaged (Cracked, Condensation, etc.)',
  'Dents or Dings',
  'Foreign Material Present',
  'Paint - Other Issue',
  'Paint - Overspray',
  'Road Rash / Chips',
  'Scrapes or Scratches',
  'Tint Removal',
  'Trim Damaged / Loose / Missing',
  'Weather Striping',
  'Other Issue'
];

export const interiorIssueDescription = [
  'Burn Mark',
  'Cut / Rip / Torn',
  'Detached / Loose',
  'Faded / Worn',
  'Missing Part / Piece',
  'Scrapes or Scratches',
  'Other'
];

export const windshieldGlassIssueDescription = [
  'Chip',
  'Crack',
  'Tint Removal'
];

// Question 4
export const fromSubLocation = {
  cosmeticexterior: exteriorIssueDescription,
  cosmeticinterior: interiorIssueDescription,
  windshieldglass: windshieldGlassIssueDescription
};

export const skipSubLocation = [
  'Grille',
  'Hood',
  'Trunk / Lift Gate',
  'Headlight',
  'Taillight',
  'Pillar',
  'Windshield',
  'Rear Window'
];
